import { FC, useCallback, useState } from "react"
import { productCategoryDeleteApi } from "src/domain/api/productCategory/productCategoryDeleteApi"
import { ProductCategory } from "src/domain/entities/productCategory"
import { useAuth } from "../../../domain/hooks"
import { getErrorMessage } from "../../../utils/helpers"
import DeleteItemDialog from "../../shared/DeleteItemDialog"

interface Props {
	productCategory: ProductCategory
	isOpen: boolean
	setIsOpen: (isOpen: boolean) => void
	onSuccess?: () => void
}

export const ProductCategoryDeleteDialogController: FC<Props> = ({
	isOpen,
	setIsOpen,
	productCategory,
	onSuccess,
}) => {
	const { token } = useAuth()
	const [isLoading, setIsLoading] = useState(false)
	const [errorMessage, setErrorMessage] = useState<string | null>(null)

	const handleProductCategoryDelete = useCallback(async () => {
		try {
			setIsLoading(true)
			await productCategoryDeleteApi({ id: productCategory.id }, token)
			setIsOpen(false)
			onSuccess && onSuccess()
		} catch (err) {
			setErrorMessage(getErrorMessage(err))
		} finally {
			setIsLoading(false)
		}
	}, [productCategory, setIsOpen, token, onSuccess])

	return (
		<DeleteItemDialog
			title={`Delete ProductCategory: ${productCategory.name.en}`}
			isOpen={isOpen}
			onCancel={() => {
				setIsOpen(false)
				setErrorMessage(null)
			}}
			onDelete={handleProductCategoryDelete}
			isLoading={isLoading}
			errorMessage={errorMessage}
		/>
	)
}
